/**
 * Replaces image in the DOM with a Fancybox link wrapper and the image inside it
 */
export function replaceImageWithFancybox(imgNode) {
  const parentEl = imgNode.parentNode;
  const clonedImgEl = imgNode.cloneNode(true);

  // Creates Fancybox link with cloned image
  const fancyBoxImage = document.createElement('a');
  fancyBoxImage.setAttribute('href', clonedImgEl.getAttribute('src'));
  fancyBoxImage.setAttribute('data-fancybox', '');
  fancyBoxImage.insertBefore(clonedImgEl, fancyBoxImage.firstChild);

  // Removes existing content
  parentEl.innerHTML = '';

  // Adds image wrapped by FancyBox
  parentEl.insertBefore(fancyBoxImage, parentEl.firstChild);
}
